export const NEW_PASSWORD_MIN_LENGTH = 6;

export function validateNewPassword(newPassword: string, confirmPassword: string): string | null {
  if (newPassword.length < NEW_PASSWORD_MIN_LENGTH) {
    return `Password must be at least ${NEW_PASSWORD_MIN_LENGTH} characters.`;
  }
  if (newPassword !== confirmPassword) {
    return 'Passwords do not match.';
  }
  return null;
}
